import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getConversationQueryKey } from "modules/conversations/lib/conversationQuery"
import { getCustomerNotesQueryKey } from "modules/notes/lib/customerNotesQuery"
import { DataResponse, NoteResponseDataSchema } from "schema"
import { z } from "zod"

type Params = {
  id?: string
  conversationId: string
  customerId?: string
  text: string
}

type Response = DataResponse<z.infer<typeof NoteResponseDataSchema>>

export function useUpsertNoteMutation() {
  const queryClient = useQueryClient()

  return useMutation<Response, Error, Params>({
    mutationFn: async (params) => {
      const url = params.id ? `/notes/${params.id}` : "/notes"
      const response = await axios.post<Response>(url, {
        text: params.text,
        conversationId: params.conversationId,
      })
      return response.data
    },
    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries({
        queryKey: getConversationQueryKey(variables.conversationId),
      })
      if (variables.customerId) {
        queryClient.invalidateQueries({
          queryKey: getCustomerNotesQueryKey(variables.customerId),
        })
      }
    },
  })
}
